import { IGlobalState } from 'store';

export const selectors = {
	getActivityId: (state: IGlobalState) => state.followUps.create.activityId,
	getInitAction: (state: IGlobalState) => state.followUps.create.init,
	getCreateAction: (state: IGlobalState) => state.followUps.create.create,
	getOpen: (state: IGlobalState) => state.followUps.create.open,
	getDurations: (state: IGlobalState) => state.followUps.create.durations,
	getFollowUps: (state: IGlobalState) => state.followUps.create.followUps,
	getInPersonStartTimes: (state: IGlobalState) => state.followUps.create.inPersonStartTimes,
	getOpportunityId: (state: IGlobalState) => state.followUps.create.opportunityId,
	getPhoneStartTimes: (state: IGlobalState) => state.followUps.create.phoneStartTimes,
	getOpportunityFollowUpStatus: (state: IGlobalState) => state.followUps.create.opportunityFollowUpStatus,
	getOnSuccess: (state: IGlobalState) => state.followUps.create.onSuccess,
	form: {
		getType: (state: IGlobalState) => state.followUps.create.form.formData.type,
		getDate: (state: IGlobalState) => state.followUps.create.form.formData.date,
		getTime: (state: IGlobalState) => state.followUps.create.form.formData.time,
		getLength: (state: IGlobalState) => state.followUps.create.form.formData.length,
		getSpecialInstructions: (state: IGlobalState) => state.followUps.create.form.formData.specialInstructions
	}
};
